import { useEffect, useState } from 'react';
import { OverviewPayload } from '../../types';
import { overviewService } from '../../services/overview';
/** Fetch one aggregate; ignore stale requests when scope changes. */
export function useOverview(clientId?: string, mine?: boolean, revision = 0) {
  const [data,setData] = useState<OverviewPayload>();
  const [error,setError] = useState<string | null>(null);
  const [loading,setLoading] = useState(true);
  const [retryIndex,setRetryIndex] = useState(0);
  useEffect(()=>{
    let active = true;
    setData(undefined); setLoading(true); setError(null);
    (clientId ? overviewService.client(clientId) : overviewService.consultant(mine))
      .then(result=>{if(active) setData(result);})
      .catch(()=>{if(active) setError('Overview unavailable');})
      .finally(()=>{if(active) setLoading(false);});
    return ()=>{active=false;};
  },[clientId,mine,retryIndex,revision]);
  return {data,error,loading,retry:()=>setRetryIndex(i=>i+1)};
}
